export const ROUTE_LENGTH_WITHOUT_PROVIDER = 3;
export const OLD_ROUTE_DEFAULT_LENGTH = 3;
